import React from 'react';
import { Box } from '@hover/blueprint';
import { iMapPin, iUsers } from '@hover/icons';
import ReactHtmlParser from 'react-html-parser';
import styled from '@emotion/styled';
import JobPostBadge from './JobPostBadge';

interface Props {
  content: string;
  office: string;
  department: string;
}

const JobDescriptionBox = styled.div`
  text-align: left;
  font-size: 1rem;
  p {
    font-size: 1rem;
    line-height: 1.5;
    margin: 1.25rem 0;
  }
  ul {
    margin-left: 1.5rem;
  }
`;

const Content: React.FC<Props> = ({ content, office, department }) => (
  <Box flexDir="column" mt={{ base: 600, tablet: 800 }}>
    <Box d={{ base: 'flex', tablet: 'none' }} mb={600}>
      <JobPostBadge mr={600} bg="neutral.100" icon={iMapPin} title={office} />
      <JobPostBadge bg="neutral.100" icon={iUsers} title={department} />
    </Box>
    <JobDescriptionBox>{ReactHtmlParser(content)}</JobDescriptionBox>
  </Box>
);

export default Content;
